/**
 * Fork-specific: environment-aware console silencing.
 *
 * `window.ENV` is injected at build time from the `ENV` env var ('PROD' | 'DEV',
 * see the build configs / index.html template). In any non-DEV environment we
 * silence `console.log` / `console.debug` so the deployed viewer console stays
 * quiet. `console.warn` / `console.error` are always kept — they signal real
 * problems.
 *
 * `alwaysLog` keeps a reference to the original `console.log` for the rare log
 * that must survive the silencing (currently the favorites "Adicionar Imagens
 * como Anexo" stub in `@ohif/extension-default`'s `FavoritesModal`).
 */
const originalLog = console.log.bind(console);

export const alwaysLog = (...args: unknown[]): void => originalLog(...args);

export const isDevEnv = (): boolean =>
  typeof window !== 'undefined' && (window as any).ENV === 'DEV';

let applied = false;

/** Silence console.log/console.debug unless running with window.ENV === 'DEV'. */
export function applyEnvLogging(): void {
  if (applied || isDevEnv()) {
    return;
  }
  applied = true;
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
}
